import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { apiUrl } from "src/app/global/global";
import { AdminService } from "src/app/services/admin.service";
import { ImageUrls } from "src/app/services/s3buket";
import { HttpClient, HttpParams } from "@angular/common/http";
import * as CONSTANT from "src/app/services/constants";

@Component({
  selector: "app-employer-listing",
  templateUrl: "./employer-listing.component.html",
  styleUrls: ["./employer-listing.component.css"]
})
export class EmployerListingComponent implements OnInit {

  recruiterImagePath = ImageUrls.BaseUrl + ImageUrls.directories.recruiter;
  employersList: any = [];
  queryType = "";
  queryFilters;
  apiUrl;
  limit = 100;
	skip = 1;
  currentPage:any;
  pagination = {limit: CONSTANT.LIMIT, maxSize: CONSTANT.MAX_SIZE, skip: 0, totalItems: ""}
  constructor(public route: ActivatedRoute,private api: AdminService) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => { 
      this.queryType = params['type'];
      this.queryFilters = params['filters'];
  });
    this.getEmployersList();
  }

  getEmployersList() {
    let params = new HttpParams(); 
    params = params.append("skip", this.skip.toString());
		params = params.append("limit", this.limit.toString());
		// params = params.append("limit", this.pagination.limit.toString());
    if(this.queryType == "viewreport"){
		params = params.append("filter", this.queryFilters);
    this.api.getData(apiUrl._getReportRecruiterAction, params).subscribe(res => {
      this.pagination.totalItems = res.totalAllCount; 
      this.employersList = res.data.listing; 
      console.log(res.data,'employersList');
    })
    } else{ 
      this.api.getData(apiUrl._employersList, params).subscribe(res => {
        this.employersList = res.data.data; 
        console.log(res.data,'employersList');
      })
    }
  }

pageChanged(event: any): void {
  if (event == this.currentPage) return;
  this.currentPage = event;
  this.pagination.skip = (event - 1) * this.pagination.limit;
  window.scroll(0, 0);
  this.getEmployersList();
} 

}